<template>
  <!-- 票券领取 线下课 -->
  <div class="course-info" v-if="!showInfo">
    <!-- v-if="goodsFlag==1" -->
    <open-app-bar v-if="dataInfo.receiveStatus==0" @click="openApp"></open-app-bar>
    <!-- dataInfo.receiveStatus 领取状态：0：已领完，1：可以领取-->
    <div class="flex-c mt100" v-if="dataInfo.receiveStatus==0">
      <img src="@/assets/images/sad.png" alt />
      <span class="f30 color-333 fb ml20">晚了一步</span>
    </div>
    <div class="c-img-info mt80">
      <img src="@/assets/images/envelopes.png" alt />
      <div class="c-content">
        <img :src="dataInfo.goodsImage" alt />
        <div class="text">
          <div class="title">{{dataInfo.goodsName}}</div>
          <div class="desc">{{dataInfo.shareDescription}}</div>
          <div
            class="info"
          >{{dates.formatDate(new Date(dataInfo.startTime), 'yyyy-MM-dd')}}-{{dates.formatDate(new Date(dataInfo.endTime), 'yyyy-MM-dd')}}</div>
          <div class="info">{{dataInfo.city}}| {{dataInfo.venuesName}}</div>
          <div class="f30 color-f5 fb">¥{{dataInfo.goodsPrice}}</div>
        </div>
      </div>
    </div>
    <gxxt-button
      class="mt100 w686"
      type="primary"
      v-if="dataInfo.receiveStatus==1"
      @click="openUserInfo"
    >立即领取</gxxt-button>
    <div class="f30 color-333 c-btttom fb">
      <span class="mr20"></span>
      <!--receiveStatus 0：已领完，1：可以领取 -->
      <div>共{{dataInfo.shareNum}}张,{{dataInfo.receiveStatus==0?'已领完':dataInfo.receiveNum==0?'暂未被领取':`已领取${dataInfo.receiveNum}份`}}</div>
      <span class="ml20"></span>
    </div>
    <div
      class="f30 color-888 mt20"
    >领取有效期至：{{dates.formatDate(new Date(dataInfo.endTime), 'yyyy-MM-dd') }}</div>
  </div>
  <registrationInfo class="fixed-top" v-else @confirm="updateSignUpBySender"></registrationInfo>
</template>
<script>
import { setShareInfo } from '@/utils/storage'
import { wxShare } from '@/utils/wx-config'
import dates from '@/utils/dates'
import { GxxtButton } from '@/components'
import registrationInfo from '@/pages/registration/registration-info.vue'
export default {
  components: {
    GxxtButton,
    registrationInfo,
  },
  data() {
    return {
      dataInfo: {},
      id: '',
      userInfo: {},
      jumpType: 0,
      dates,
      loading: false,

      // query参数
      orderNo: '',
      shareKey: '',
      showInfo: false,
    }
  },
  created() {
    this.orderNo = this.$route.query.orderNo
    this.shareKey = this.$route.query.shareKey
    this.getOrderInfo()
  },
  computed: {
    goodsFlag() {
      return this.dataInfo.goodsNum - this.dataInfo.goodsClaimNum
    },
  },
  methods: {
    async getOrderInfo() {
      let data = {
        orderNo: this.orderNo,
        shareKey: this.shareKey,
      }
      let res = await this.api.course.offLineOrderInfo(data)
      if (res.code == 200) {
        this.dataInfo = res.data
        let shareInfo = {
          title: res.data.goodsName,
          desc: this.dataInfo.shareDescription,
          link: window.location.href,
          imgUrl: this.dataInfo.shareImage,
        }
        setShareInfo(shareInfo)
        wxShare({
          shareInfo,
        })
      }
    },
    openUserInfo() {
      this.showInfo = true
    },
    //私教坊领取票劵
    async updateSignUpBySender(form) {
      let params = {
        userName: form.realName,
        mobile: form.mobile,
        orderNo: this.orderNo,
        shareKey: this.shareKey,
      }
      let res = await this.api.course.updateSignUpBysender(params)
      if (res && res.code == 200) {
        this.$router.push({
          name: 'qrCore',
          query: {
            id: this.orderNo,
            jumpType: 0,
          },
        })
      } else {
        if (res && res.code == 1501) {
          this.$toaster({
            message: res.message,
          })
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.course-info {
  width: 100%;
  height: 100%;
  background: #ffffff;

  .c-img-info {
    width: 726;
    height: 628px;
    padding: 0 12px;
    box-sizing: border-box;
    position: relative;

    img {
      width: 100%;
      height: 628px;
      display: block;
    }

    .c-content {
      width: 550px;
      height: 200px;
      position: absolute;
      top: 134px;
      left: 100px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      img {
        width: 150px;
        height: 200px;
        border-radius: 8px;
        margin-right: 30px;
      }

      .text {
        width: 370px;
        display: flex;
        flex-direction: column;

        .title {
          font-size: 30px;
          font-weight: 500;
          color: #333333;
          line-height: 42px;
        }

        .desc {
          font-size: 26px;
          color: #888888;
          line-height: 26px;
          margin: 14px 0 16px;
        }

        .info {
          font-size: 24px;
          font-weight: 500;
          color: #bbbbbb;
          line-height: 36px;
        }

        > div {
          width: 370px;
          text-align: left;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          white-space: nowrap !important;
        }
      }
    }
  }

  .c-btttom {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 70px;

    span {
      width: 106px;
      height: 2px;
      display: block;
      border-top: 2px solid #d8d8d8;
    }
  }
}
.fixed-top {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  z-index: 99;
}
</style>
